import {
  Box,
  Typography
} from '@mui/material';
import React, { useState } from 'react';

import { VoterGroupsFilters } from '../../../types';
import VoterGroupsForm from './VoterGroupsForm';
import VoterGroupsPrecinctReport from './VoterGroupsPrecinctReport';

interface VoterGroupsReportProps {
}

const VoterGroupsReport: React.FC<VoterGroupsReportProps> = () => {
  const [filters, setFilters] = useState<VoterGroupsFilters>();

  const onGenerateReport = (filters: VoterGroupsFilters) => {
    console.log('Generating report with filters:', filters);
    setFilters(filters);
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Voters and Leaders
      </Typography>
      <VoterGroupsForm onGenerateReport={onGenerateReport} />
      { filters && <VoterGroupsPrecinctReport filters={filters} /> }
    </Box>
  );
};

export default VoterGroupsReport;
